var Navbar = /** @class */ (function () {
    function Navbar(app) {
        this.app = app;
        this.el = this.app.el.querySelector('.tc-top-navbar');
        if (this.el) {
            this.burgerIcon = this.el.querySelector('.navbar-burger');
            this.menuElem = this.el.querySelector('.navbar-menu');
        }
    }
    Navbar.prototype.toggleMobileMenu = function () {
        if (this.burgerIcon && this.menuElem) {
            if (this.burgerIcon.classList.contains('is-active')) {
                this.burgerIcon.classList.remove('is-active');
                this.menuElem.classList.remove('is-active');
            }
            else {
                this.burgerIcon.classList.add('is-active');
                this.menuElem.classList.add('is-active');
            }
        }
    };
    return Navbar;
}());
export default Navbar;
